/**
 * useMe — fetches /api/me once on auth and caches the result.
 * Returns null while loading or unauthenticated.
 */
import { useEffect, useState } from 'react';
import { useAuth } from './useAuth';
import { getMe, MeResponse } from '@/api/client';

let cached: MeResponse | null = null;

export function useMe(): MeResponse | null {
    const { getToken, isAuthenticated } = useAuth();
    const [me, setMe] = useState<MeResponse | null>(cached);

    useEffect(() => {
        if (!isAuthenticated) {
            cached = null;
            setMe(null);
            return;
        }
        if (cached) {
            setMe(cached);
            return;
        }
        let cancelled = false;
        (async () => {
            try {
                const token = await getToken();
                const data = await getMe(token);
                if (cancelled) return;
                cached = data;
                setMe(data);
            } catch {
                if (!cancelled) setMe(null);
            }
        })();
        return () => { cancelled = true; };
    }, [isAuthenticated, getToken]);

    return me;
}
